import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AzureApiService } from "../../services/azure-api.service";
import {DtoEventAction} from "../../shared/models/DtoEventAction";
import {DtoSaveResult} from "../../shared/models/DtoSaveResult";
import {DtoDeleteResult} from "../../shared/models/DtoDeleteResult";
import {ActionType} from "../../shared/enums/actionType";

@Injectable()
export class SettingsEventActionService {
    private apiUrlEventAction: string;

    constructor(private http: AzureApiService) {
        this.apiUrlEventAction = 'eventaction'
    }

    public getEventActions = (): Observable<DtoEventAction[]> => {
        return this.http.get<DtoEventAction[]>(`${this.apiUrlEventAction}`);
    };

    public getEventActionsForTypes = (types: ActionType[]): Observable<DtoEventAction[]> => {
        return this.http.post<DtoEventAction[]>(`${this.apiUrlEventAction}/types`, types);
    };

    public getEventActionById = (id: number): Observable<DtoEventAction> => {
        return this.http.get<DtoEventAction>(`${this.apiUrlEventAction}/${id}`);
    };

    public saveEventAction = (dtoObject: DtoEventAction): Observable<DtoSaveResult> => {
        return this.http.post<DtoSaveResult>(this.apiUrlEventAction, dtoObject);
    };

    public deleteEventActionById = (id: number): Observable<DtoDeleteResult> => {
        return this.http.delete<DtoDeleteResult>(`${this.apiUrlEventAction}/${id}`);
    };

    public getEventActionNextIndex = (type: number): Observable<number> => {
        return this.http.get<number>(`${this.apiUrlEventAction}/nextindex/${type}`);
    };

    public checkEventActionIndexAvailable = (type: number, id: number, index: number): Observable<boolean> => {
        return this.http.get<boolean>(`${this.apiUrlEventAction}/indexavailable/${type}/${id}/${index}`);
    };
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/settings/settings-eventaction/settings-eventaction.service.ts